/** Server-side pagination policy, mirrored here so screens do not guess it. */
export const PAGE_SIZE = 50
export const MAX_PAGE_SIZE = 200

/** Event statuses, in lifecycle order. Values are lowercase on the wire. */
export const EVENT_STATUSES = [
  "draft",
  "scheduled",
  "confirmed",
  "completed",
  "cancelled",
] as const

/** Record statuses carry attendance only. Sign-off is a separate fact. */
export const RECORD_STATUSES = ["scheduled", "attended", "no_show"] as const

export const STATUS_LABELS: Record<string, string> = {
  draft: "Draft",
  scheduled: "Scheduled",
  confirmed: "Confirmed",
  completed: "Completed",
  cancelled: "Cancelled",
  attended: "Attended",
  no_show: "No-show",
  active: "Active",
  inactive: "Inactive",
  lump_sum: "Lump sum divided",
  per_person: "Per person",
}

export const STATUS_TONES: Record<
  string,
  "neutral" | "info" | "success" | "warning" | "notice" | "danger"
> = {
  draft: "neutral",
  scheduled: "info",
  // Committed but not yet delivered: the in-between deserves its own colour,
  // or scheduled and confirmed read as the same state at a glance.
  confirmed: "notice",
  completed: "success",
  cancelled: "danger",
  attended: "success",
  // A no-show is the bad outcome of a booked seat, and the design reference
  // styles it as such. It stays a signable fact; the colour is not a veto.
  no_show: "danger",
  active: "success",
  inactive: "neutral",
}

/** The seven cost categories. Closed list: no more and no fewer. */
export const COST_LINES = [
  { key: "cost_provider", label: "Provider" },
  { key: "cost_venue", label: "Venue" },
  { key: "cost_travel", label: "Travel" },
  { key: "cost_accommodation", label: "Accommodation" },
  { key: "cost_material", label: "Training material" },
  { key: "cost_catering", label: "Catering" },
  { key: "cost_other", label: "Other" },
] as const
